import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-5821">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-5822">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-5823">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-5824">
            <ArrowLeft className="w-4 h-4" data-id="element-5825" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-5826">NOIZA</div>
          <div className="w-20" data-id="element-5827" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-5828">
        <div className="mb-12" data-id="element-5829">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-5830">
            <FileText className="w-6 h-6 text-white/80" data-id="element-5831" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-5832">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-5833">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-5834">
          <section data-id="element-5835">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5836">
              <span className="text-[#006847]" data-id="element-5837">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5838">
              <p data-id="element-5839">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-5840">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5841">
                <li data-id="element-5842">Haber leído íntegramente este documento</li>
                <li data-id="element-5843">Comprender su contenido en su totalidad</li>
                <li data-id="element-5844">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-5845">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-5846">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5847">
              <span className="text-[#006847]" data-id="element-5848">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5849">
              <p data-id="element-5850">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5851">
                <li data-id="element-5852">Software como servicio (SaaS)</li>
                <li data-id="element-5853">Marketplace digital gastronómico</li>
                <li data-id="element-5854">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-5855">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5856">
                <li data-id="element-5857">Mostrar su menú digital</li>
                <li data-id="element-5858">Recibir pedidos de clientes</li>
                <li data-id="element-5859">Gestionar su operación interna</li>
                <li data-id="element-5860">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-5861">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-5862">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5863">
              <span className="text-[#006847]" data-id="element-5864">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5865">
              <p data-id="element-5866">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5867">
                <li data-id="element-5868">No es proveedor de alimentos</li>
                <li data-id="element-5869">No participa en la preparación de productos</li>
                <li data-id="element-5870">No manipula alimentos en ningún momento</li>
                <li data-id="element-5871">No realiza entregas ni logística</li>
                <li data-id="element-5872">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-5873">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-5874">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-5875">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5876">
              <span className="text-[#006847]" data-id="element-5877">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-5878">
              <p data-id="element-5879">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-5880">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5881">
                <li data-id="element-5882">El restaurante es el único responsable de su operación</li>
                <li data-id="element-5883">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-5884">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-5885">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5886">
                <li data-id="element-5887">Precios</li>
                <li data-id="element-5888">Menú</li>
                <li data-id="element-5889">Horarios</li>
                <li data-id="element-5890">Métodos de pago</li>
                <li data-id="element-5891">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5892">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5893">
              <span className="text-[#006847]" data-id="element-5894">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-5895">
              <div data-id="element-5896">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5897">
                  5.1. Alcance general
                </h3>
                <p data-id="element-5898">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-5899">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5900">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-5901">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5902">
                  <li data-id="element-5903">Calidad de los alimentos</li>
                  <li data-id="element-5904">Estado, frescura o preparación</li>
                  <li data-id="element-5905">Ingredientes utilizados</li>
                  <li data-id="element-5906">Contaminación cruzada</li>
                  <li data-id="element-5907">Problemas de higiene o salubridad</li>
                  <li data-id="element-5908">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5909">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-5910">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5911">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-5912">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5913">
                  <li data-id="element-5914">Retrasos en la entrega</li>
                  <li data-id="element-5915">Pérdida de pedidos</li>
                  <li data-id="element-5916">Entregas incompletas</li>
                  <li data-id="element-5917">Errores en dirección</li>
                  <li data-id="element-5918">Conducta de repartidores</li>
                  <li data-id="element-5919">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-5920">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5921">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-5922">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-5923">
                  <li data-id="element-5924">Recepción de pagos</li>
                  <li data-id="element-5925">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-5926">Manejo de efectivo</li>
                  <li data-id="element-5927">Confirmación de pagos</li>
                  <li data-id="element-5928">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-5929">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5930">
                  <li data-id="element-5931">Pagos no recibidos</li>
                  <li data-id="element-5932">Comprobantes falsos</li>
                  <li data-id="element-5933">Errores en montos</li>
                  <li data-id="element-5934">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-5935">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5936">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-5937">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5938">
                  <li data-id="element-5939">Reclamos de clientes</li>
                  <li data-id="element-5940">Reembolsos</li>
                  <li data-id="element-5941">Cancelaciones</li>
                  <li data-id="element-5942">Disputas</li>
                  <li data-id="element-5943">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5944">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-5945">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5946">
              <span className="text-[#006847]" data-id="element-5947">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-5948">
              <p data-id="element-5949">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5950">
                <li data-id="element-5951">Responsable</li>
                <li data-id="element-5952">Legal</li>
                <li data-id="element-5953">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-5954">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5955">
                <li data-id="element-5956">Publicar información falsa</li>
                <li data-id="element-5957">Manipular precios de forma engañosa</li>
                <li data-id="element-5958">Simular disponibilidad inexistente</li>
                <li data-id="element-5959">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5960">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5961">
              <span className="text-[#006847]" data-id="element-5962">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-5963">
              <p data-id="element-5964">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5965">
                <li data-id="element-5966">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-5967">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-5968">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5969">
                <li data-id="element-5970">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-5971">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-5972">
                    <li data-id="element-5973">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-5974">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-5975">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5976">
              <span className="text-[#006847]" data-id="element-5977">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-5978">
              <p data-id="element-5979">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5980">
                <li data-id="element-5981">Menú digital</li>
                <li data-id="element-5982">Gestión de pedidos</li>
                <li data-id="element-5983">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-5984">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5985">
                  <p className="font-medium text-white mb-2" data-id="element-5986">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5987">
                    <li data-id="element-5988">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5989">
                  <p className="font-medium text-white mb-2" data-id="element-5990">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5991">
                    <li data-id="element-5992">Propiedad del software</li>
                    <li data-id="element-5993">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-5994">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-5995">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5996">
              <span className="text-[#006847]" data-id="element-5997">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5998">
              <p data-id="element-5999">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6000">
                <li data-id="element-6001">Disponibilidad continua</li>
                <li data-id="element-6002">Funcionamiento sin interrupciones</li>
                <li data-id="element-6003">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6004">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6005">
                <li data-id="element-6006">Fallas técnicas</li>
                <li data-id="element-6007">Actualizaciones</li>
                <li data-id="element-6008">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6009">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6010">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6011">
              <span className="text-[#006847]" data-id="element-6012">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6013">
              <p data-id="element-6014">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6015">
                <li data-id="element-6016">No está garantizada permanentemente</li>
                <li data-id="element-6017">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6018">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6019">
                <li data-id="element-6020">Destacar o no restaurantes</li>
                <li data-id="element-6021">Modificar posiciones</li>
                <li data-id="element-6022">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6023">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6024">
              <span className="text-[#006847]" data-id="element-6025">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6026">
              <p data-id="element-6027">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6028">
                <li data-id="element-6029">Cumplir con los pagos acordados</li>
                <li data-id="element-6030">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6031">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6032">
                <li data-id="element-6033">Suspender el servicio</li>
                <li data-id="element-6034">Limitar funcionalidades</li>
                <li data-id="element-6035">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6036">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6037">
              <span className="text-[#006847]" data-id="element-6038">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6039">
              <p data-id="element-6040">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6041">
                <li data-id="element-6042">Incumplimiento de términos</li>
                <li data-id="element-6043">Uso indebido</li>
                <li data-id="element-6044">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6045">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6046">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6047">
              <span className="text-[#006847]" data-id="element-6048">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6049">
              <p data-id="element-6050">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6051">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6052">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6053">
              <span className="text-[#006847]" data-id="element-6054">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6055">
              <p data-id="element-6056">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6057">
                <li data-id="element-6058">Pérdidas económicas</li>
                <li data-id="element-6059">Daños indirectos</li>
                <li data-id="element-6060">Lucro cesante</li>
                <li data-id="element-6061">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6062">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6063">
              <span className="text-[#006847]" data-id="element-6064">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6065">
              <p data-id="element-6066">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6067">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6068">
              <span className="text-[#006847]" data-id="element-6069">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6070">
              <p className="font-medium" data-id="element-6071">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6072">
                <li data-id="element-6073">Ha leído este documento completo</li>
                <li data-id="element-6074">Comprende su alcance</li>
                <li data-id="element-6075">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}